import supplierInitialState from './supplier-initial-state';
import contractorInitialState from './contractor-initial-state';
import * as cnt from './constants';
import R from 'ramda';

export const initDashboard = (companyType) => (dispatch, getState) => {
  if (companyType === 'Supplier') {
    const { locAccess: locationsList, company: { productType } } = getState().user.toJS();
    return dispatch({
      type: cnt.INIT_DASHBOARD,
      payload: {
        initialState: {
          ...supplierInitialState,
          globalFilters: {
            ...supplierInitialState.globalFilters,
            locations: {
              ...supplierInitialState.globalFilters.locations,
              list: locationsList
                .filter(obj => obj.contracting.indexOf('read') > -1)
                .map(obj => R.assoc('title', obj.property_name, obj)),
              title: productType === 'Accommodation' ? 'Properties' : 'Locations',
            }
          }
        },
      }
    });
  }
  return dispatch({
    type: cnt.INIT_DASHBOARD,
    payload: {
      initialState: contractorInitialState,
    }
  });
};

export const loadDashboard = () => ({
  type: cnt.LOAD_DASHBOARD,
})

export const updateGlobalListFilter = payload => ({
  type: cnt.UPDATE_GLOBAL_LIST_FILTER,
  payload,
})

export const clearListFilter = payload => ({
  type: cnt.CLEAR_GLOBAL_LIST_FILTER,
  payload,
});

export const resetGlobalFilters = () => ({
  type: cnt.RESET_GLOBAL_DASHBOARD_FILTER,
})


export const loadContractFolders = () => ({
  type: cnt.LOAD_FOLDERS,
});

export const updateFilter = (filterItem, value) => ({
  type: cnt.UPDATE_GLOBAL_FILTER, payload: { filterItem, value }
});

export const updateWidgetFilter = (id, filterBy, filterObjSelected) => ({
  type: cnt.UPDATE_WIDGET_FILTER, payload: { id, filterBy, filterObjSelected },
});



// WEBPACK FOOTER //
// ./src/app/components/contracting-dashboard/__storeFiles__/actions.js